import React from 'react'
import styled from 'styled-components'
import { Formik, Form, Field } from 'formik'
import { checkbox } from '../../../styles/checkbox'
import { button } from '../../../styles/button'

const Partners = (): JSX.Element => (
  <Wrapper>
    <Formik
      initialValues={{
        partners: [],
      }}
      onSubmit={values => {
        console.log(values)
      }}
    >
      <Form>
        <div className="form">
          <h4>Partenaires</h4>
          <div className="checkbox-groups">
            <div className="checkbox--group">
              <label>
                <Field
                  className="checkbox"
                  type="checkbox"
                  name="partners"
                  value="Formaliste"
                />
                <span>Formaliste</span>
              </label>
              <label>
                <Field
                  className="checkbox"
                  type="checkbox"
                  name="partners"
                  value="Assurance"
                />
                <span>Assurance</span>
              </label>
            </div>
            <div className="checkbox--group">
              <label>
                <Field
                  className="checkbox"
                  type="checkbox"
                  name="partners"
                  value="Banque"
                />
                <span>Banque</span>
              </label>
              <label>
                <Field
                  className="checkbox"
                  type="checkbox"
                  name="partners"
                  value="Expert comptable"
                />
                <span>Expert comptable</span>
              </label>
            </div>
          </div>
        </div>
        <button type="submit">PARTAGER LE LEAD</button>
      </Form>
    </Formik>
  </Wrapper>
)

const Wrapper = styled.div`
  label {
    min-width: 200px;
  }

  .form {
    display: flex;
    flex-direction: column;
  }

  .checkbox-groups {
    flex-direction: row;
  }

  .checkbox--group {
    flex-direction: column;
  }

  ${button}
  ${checkbox}
`

export default Partners
